import Vue from 'vue';
import App from './App.vue';
import router from './router';
import jasonVueNavigation from '../src/index';

Vue.config.productionTip = false;
Vue.use(jasonVueNavigation, router);
Vue.mixin({
  data () {
    return {
      random: Math.random() * 100
    };
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
